import React from 'react';
import ProgressLabel from '../ProgressLabel';

const RecoveringLabel = () => (
    <ProgressLabel text="Recovering" color="blue" />
);

export default RecoveringLabel;
